import { css, jsx } from "@emotion/react";
import styled from "@emotion/styled";
import { MOBILE_WIDTH } from "../../../../../utils/HelperStyles";
import StyledButton from "../../../../StyledButton";
import StyledInput from "../../../../StyledInput";

const styledModalScrollbar = css`
  /* ::-webkit-scrollbar {
    width: 7px;
  }

  ::-webkit-scrollbar-track {
    background: #dcdfe3;
  }

  ::-webkit-scrollbar-thumb {
    background: #848688;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555b5f;
  } */
`;

export const TiersContainer = styled.div`
  border-bottom: 1px solid #eceeef;
  padding: 25px 25px;
  padding-bottom: 35px;
`;

export const ActivateLeftContainer = styled.div`
  border: 1px solid #eceeef;
  /* margin: 25px 0px; */
  background-color: white;
  /* padding: 25px 25px; */
  width: 100%;
  width: 720px;
  position: relative;

  @media (max-width: ${MOBILE_WIDTH}) {
    border-right: none;
    margin-top: 50px;
  }
`;

export const ActivateAccountContainer = styled.div`
  border-bottom: 1px solid #eceeef;
  padding: 34px 50px 44px;
`;

export const ActivationTitle = styled.div`
  font: normal normal bold 24px "Source Sans Pro";
  padding-bottom: 0px;
  color: #333;
`;

export const ActivationSubtitle = styled.div`
  font: normal normal normal 15px "Source Sans Pro";
  color: #707070;
  padding-bottom: 19px;
`;

export const MonthSuffix = styled.span`
  font-weight: normal;
  height: 100%;
  display: flex;
  align-items: center;
  padding-top: 9px;
  font-size: 18px;
`;

export const CardAdsContainer = styled.div`
  width: 100%;
  background: white 0% 0% no-repeat padding-box;
  border-radius: 5px;
  border: 1px solid #eceeef;
`;

export const CardAdsHeader = styled.div`
  display: grid;
  grid-template-columns: max-content max-content;
  justify-content: space-between;
  font: normal normal bold 16px/19px "Lato";
  padding: 14px 20px 12px 20px;
  color: #333;
`;

export const Price = styled.div`
  font: normal normal 900 21px/18px "Lato";
  color: #333;
  text-align: right;

  > span {
    font: normal normal normal 15px/18px "Lato";
    color: #555b5f;
    margin-left: 3px;
  }
`;

export const DollarSign = styled.span`
  display: inline-block;
  vertical-align: top;
  text-align: left;
  font: normal normal normal 16px/19px "Lato";
  color: #555b5f;
`;

export const CardsAdsContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  padding-bottom: 22px;
`;

export const CardAdsItems = styled.div`
  display: inline-flex;

  font: normal normal normal 14px/26px "Lato";
  color: #333;

  > span {
    margin-left: 7px;
  }
`;

export const PurchaseContainer = styled.div`
  padding: 0 50px;
`;

export const PurchaseAdditionalTitle = styled.div`
  font: normal normal 900 16px/19px "Lato";
  color: #333;
  padding-bottom: 12px;
`;

export const CardTierContainer = styled.div<{ active?: boolean }>`
  font: normal normal normal 12px "Source Sans Pro";
  margin: 15px 0px;
  color: #555b5f;

  cursor: pointer;

  display: flex;
  justify-content: space-between;

  padding: 16px 5% 18px 5%;
  width: 100%;
  height: 70px;

  background: ${(props) => (props.active ? "#FFF2E5" : "#fff")};
  border-radius: 5px;
  border: 1px solid ${(props) => (props.active ? "#FB972E" : "#ECEEEF")};

  > * > div > p {
    margin: 0;
    font: normal normal bold 18px "Source Sans Pro";
    color: #333;
  }

  div:div:last-child {
    text-align: right;
  }

  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const CardAdditionalContainer = styled.div<{ active?: boolean }>`
  font: normal normal normal 14px "Lato";
  margin: 15px 0px;
  color: #555b5f;

  display: flex;
  justify-content: space-between;

  padding: 16px 5% 18px 5%;
  width: 100%;
  height: 98px;

  background: #fff;
  border-radius: 5px;
  border: 1px solid #eceeef;

  > * > div > p {
    margin: 0;
    font: normal normal bold 18px/22px "Lato";
    color: #333;
  }

  div:div:last-child {
    text-align: right;
  }
`;

export const TotalDiv = styled.div`
  margin: 0;
  font: normal normal 900 24px "Lato";
  font-size: 24px;
  color: #333;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 33%;
`;

export const RadioButtonDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  // Remove Arrows from number input
  -moz-appearance: textfield;
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const InnerRadioButtonDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 45px;

  > span {
    letter-spacing: 0.4px;
  }
`;

export const AdditionalLair = styled.div`
  font: normal normal bold 16px/18px "Lato";
  text-align: center;
  color: #5fa200;

  padding-top: 12px;
`;

export const TotalAmountContainer = styled.div`
  background: #333 0% 0% no-repeat padding-box;
  border-radius: 8px;
  width: 100%;
  height: 58px;

  padding: 18px 20px 15px 20px;
`;

export const InputQuantity = styled(StyledInput)`
  margin-top: 7.9px;
  width: 79px;
  height: 30px;
  border: 1px solid #eceeef;
  border-radius: 5px;
`;

export const TotalAmountContent = styled.div`
  display: grid;
  grid-template-columns: max-content max-content;
  justify-content: space-between;
  font: normal normal bold 16px/19px "Lato";

  div {
    font: normal normal 900 25px/21px "Lato";
    color: #fff !important;
  }

  div:first-child {
    font: normal normal bold 16px/19px "Lato";
  }

  div > span {
    color: #c6cbd0 !important;
  }
`;

export const CreditCardContainerInfo = styled.form`
  display: grid;
  grid-template-rows: max-content max-content max-content;
  background-color: #fff;
  border: 1px solid #eceeef;
  margin-top: 40px;

  overflow-y: auto;
  ${styledModalScrollbar}
  width: 100%;
  width: 720px;
  padding: 40px 0 0;

  @media (max-width: ${MOBILE_WIDTH}) {
    overflow-y: unset;
    margin-top: 30px;
    padding: 0px 20px;
    margin-bottom: 40px;
  }
`;

export const CreditCardDetails = styled.div`
  margin-bottom: 40px;
  padding: 0px 50px 40px;
  border-bottom: 1px solid #eceeef;

  @media (max-width: ${MOBILE_WIDTH}) {
    padding-bottom: 25px;
  }
`;

export const SectionTitle = styled.div`
  font: normal normal 900 18px/22px "Lato";
  color: #333;
  font-weight: 900;
  padding-bottom: 20px;
`;

export const Row = styled.div`
  margin-bottom: 20px;
`;

export const PaymentFieldName = styled.div`
  text-align: left;
  font: normal normal 600 16px "Source Sans Pro";
  letter-spacing: 0px;
  color: #333;
  padding-bottom: 8px;
`;

export const InputPayment = styled(StyledInput)<{ error: boolean }>`
  border: 1px solid ${(props) => (props.error ? "#eb1c26" : "#ECEEEF")};
  /* ${(props) => props.error && "color: #eb1c26;"} */
  font-size: 16px;
  border-radius: 4px;
  margin-top: 5.9px;
  padding-top: 6px;
  padding-bottom: 7px;
  height: 42px;
  width: 100%;
  :focus {
    box-shadow: 0px 0px 2.5px 0px rgba(0, 0, 0, 0.5);
  }
  ::placeholder {
    font-size: 16px;
  }
`;

export const InputPaymentContainer = styled.div<{
  error: boolean;
  focused: boolean;
}>`
  box-shadow: ${(props) =>
    props.focused ? "0px 0px 2.5px 0px #F4A756" : "none"};
  border: 1px solid
    ${(props) =>
      props.error ? "#eb1c26" : props.focused ? "#F4A756" : "#ECEEEF"};
  border-radius: 4px;
  height: 46px;
  padding: 0px 12px;
`;

export const SplitRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 15px;

  padding-bottom: 20px;
`;

export const BillingContainer = styled.div`
  padding: 0 50px 40px;
  border-bottom: 1px solid #eceeef;

  @media (max-width: ${MOBILE_WIDTH}) {
    padding: 25px 50px;
  }
`;

export const BillingAddressContainer = styled.div`
  border: 1px solid #eceeef;
  background-color: #f6f6f7;
  border-radius: 4px;
  margin-top: 5.9px;
  padding: 15px 25px;
  display: flex;
  font-size: 14px;
`;

export const AddressTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const AddressDescription = styled.div`
  font: normal normal 500 15px/26px "Lato";
`;

export const AddressEditButton = styled.div`
  font-weight: normal;
  font-size: 16px;
  color: #2569b8;
  cursor: pointer;
  place-self: center;
  :hover {
    text-decoration: underline;
  }
`;

export const SameAddress = styled.div`
  /* padding-top: 20px; */
  padding: 31px 50px;
  border-bottom: 1px solid #eceeef;
  display: flex;
`;

export const ShippingContainer = styled.div`
  padding: 40px 50px;
  border-top: 1px solid #eceeef;
  border-bottom: 1px solid #eceeef;

  @media (max-width: ${MOBILE_WIDTH}) {
    padding: 25px 50px;
  }
`;

export const ShippingTitle = styled.div`
  font: normal normal 900 18px/22px "Source Sans Pro";
  color: #333;
  font-weight: 900;
  padding-bottom: 5px;
`;

export const ShippingAddressContainer = styled.div<{
  isFirstEditShippingAddress?: boolean;
}>`
  border: 1px solid #eceeef;
  background-color: #f6f6f7;
  border-radius: 4px;
  margin-top: 5.9px;
  padding-top: 6px;
  padding-bottom: 7px;
  padding: 15px 25px;
  display: flex;
  flex-direction: ${(props) =>
    props.isFirstEditShippingAddress ? "row" : "column"};
  font-size: 14px;
`;

export const ShippingButtons = styled.div`
  display: flex;

  > button {
    font: normal normal bold 15px/18px "Lato";
  }

  > button:first-child {
    margin-right: 10px;
  }
`;

export const ModalFooterContainer = styled.div`
  display: grid;
  grid-template-columns: max-content max-content;
  grid-column-gap: 12px;
  padding: 40px 50px 26px 50px;
  justify-content: end;
`;

export const FooterButton = styled(StyledButton)`
  border-radius: 20px !important;
`;
